import React, { useState } from 'react';
import { Card, CardContent, Checkbox, FormControlLabel, Typography } from '@mui/material';
import { useNotify } from 'react-admin';
import { setBillingAccountAgentsBeta } from '../../Services/billingAccount';

interface Props {
	billingAccount: any;
	onChanged?: () => void;
}

// BillingAccountAgentsBetaFlag ouvre la bêta des agents IA sur un compte. C'est
// l'allowlist de la bêta : api-agents refuse tout projet dont le compte n'est pas
// coché (fail-close). La case s'AJOUTE au produit Ask AI, elle ne le remplace pas :
// un compte sans Ask AI reste fermé même coché.
export const BillingAccountAgentsBetaFlag: React.FC<Props> = ({ billingAccount, onChanged }) => {
	const notify = useNotify();
	const [checked, setChecked] = useState<boolean>(!!billingAccount.agentsBetaEnabled);
	const [saving, setSaving] = useState(false);

	const handleToggle = async (next: boolean) => {
		setChecked(next);
		setSaving(true);
		try {
			await setBillingAccountAgentsBeta(String(billingAccount.id), next);
			notify(next ? 'Agents IA ouverts sur ce compte' : 'Agents IA fermés sur ce compte', { type: 'success' });
			onChanged?.();
		} catch (err: any) {
			setChecked(!next);
			notify(err?.message || 'Échec de la mise à jour', { type: 'error' });
		} finally {
			setSaving(false);
		}
	};

	return (
		<Card style={{ width: '100%', marginTop: 16 }}>
			<CardContent>
				<Typography variant="h6" gutterBottom>
					Agents IA (bêta)
				</Typography>
				<FormControlLabel
					control={<Checkbox checked={checked} disabled={saving} onChange={(e) => handleToggle(e.target.checked)} />}
					label="Ouvrir les agents IA sur ce compte"
				/>
				<Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
					Allowlist de la bêta fermée. Le compte doit aussi avoir le produit Ask AI : la case seule n'ouvre rien.
					Les projets du compte voient alors l'écran Agents et peuvent activer leurs agents.
				</Typography>
			</CardContent>
		</Card>
	);
};
